/* eslint-disable react/forbid-elements */
import { createIcon, type ISVGIconProps, type ISVGProps } from '@cian/ui-kit-design-tokens/internal';
import * as React from 'react';

// eslint-disable-next-line react/display-name
const IconComponent = React.forwardRef((props: ISVGProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <svg {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M21 3H3a2 2 0 00-2 2v14a2 2 0 002 2h18a2 2 0 002-2V5a2 2 0 00-2-2zM6 8h12M6 12h12M6 16h5"
      />
    </svg>
  );
});

export const IconMortgageForm24: React.FC<ISVGIconProps> = createIcon(IconComponent);
